export const APPLY_LEASE_CONTRACT_FIELDS = 'APPLY_LEASE_CONTRACT_FIELDS';
export const APPLY_LEASE_CONTRACT_FIELDS_SUCCESS = 'APPLY_LEASE_CONTRACT_FIELDS_SUCCESS';
export const APPLY_LEASE_CONTRACT_FIELDS_FAILURE = 'APPLY_LEASE_CONTRACT_FIELDS_FAILURE';
export const REQUEST_LEASE_CONTRACT_FIELDS = 'REQUEST_LEASE_CONTRACT_FIELDS';
